import { alpha, darken, Theme } from '@material-ui/core/styles';
import { TableCellClassKey } from '@material-ui/core/TableCell';

const MuiTableCell = (theme: Theme): Partial<Record<TableCellClassKey, unknown>> => {
    const light = theme.palette.type === 'light';
    const borderColor = light ? theme.palette.divider : darken(alpha(theme.palette.divider, 1), 0.68);
    const backgroundColor = light ? theme.palette.grey[100] : theme.palette.grey[900];
    return {
        root: {
            borderBottom: `1px solid ${borderColor}`,
        },
        stickyHeader: {
            backgroundColor,
        },
    };
};

export default MuiTableCell;
